import { combineReducers } from 'redux';
import privateAuth from '@/redux/privateAuth.slice';
import locale from '@/redux/locale.slice';

export default combineReducers({
  locale,
  privateAuth,
});
